import { render, staticRenderFns } from "./alienCheck.vue?vue&type=template&id=356d5c00&scoped=true"
import script from "./alienCheck.vue?vue&type=script&lang=js"
export * from "./alienCheck.vue?vue&type=script&lang=js"
import style0 from "./alienCheck.vue?vue&type=style&index=0&id=356d5c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d5c00",
  null
  
)

export default component.exports